import { Navigate, Route, Routes } from 'react-router-dom';

import { AppShell } from '@/components/layout/AppShell';
import { ViewportGate } from '@/components/layout/ViewportGate';
import { RequireAuth } from '@/auth/RequireAuth';
import { isLoggedIn } from '@/auth/admin-auth';
import { LoginPage } from '@/pages/LoginPage';
import { OverviewPage } from '@/sections/overview/OverviewPage';
import { CompetitionsPage } from '@/sections/competitions/CompetitionsPage';
import { UsersAgentsPage } from '@/sections/users-and-agents/UsersAgentsPage';
import { CreatorsPage } from '@/sections/creators/CreatorsPage';
import { ContentPage } from '@/sections/content/ContentPage';
import { FeedbackPage } from '@/sections/feedback/FeedbackPage';
import { SystemPage } from '@/sections/system/SystemPage';

function RootRedirect() {
  return <Navigate to={isLoggedIn() ? '/acquisition' : '/login'} replace />;
}

export function App() {
  return (
    <ViewportGate>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/login" element={<LoginPage />} />

        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route path="/acquisition" element={<OverviewPage />} />
          <Route path="/growth" element={<Navigate to="/acquisition" replace />} />
          <Route path="/overview" element={<Navigate to="/acquisition" replace />} />
          <Route path="/competitions" element={<CompetitionsPage />} />
          <Route path="/people-and-agents" element={<UsersAgentsPage />} />
          <Route path="/users-and-agents" element={<Navigate to="/people-and-agents" replace />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/loops" element={<Navigate to="/acquisition" replace />} />
          <Route path="/creators" element={<CreatorsPage />} />
          <Route path="/game-data" element={<ContentPage />} />
          <Route path="/content" element={<Navigate to="/game-data" replace />} />
          <Route path="/elevenlabs" element={<Navigate to="/system" replace />} />
          <Route path="/ai" element={<Navigate to="/system" replace />} />
          <Route path="/predictions" element={<Navigate to="/competitions" replace />} />
          <Route path="/bracket" element={<Navigate to="/competitions" replace />} />
          <Route path="/system" element={<SystemPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ViewportGate>
  );
}
